module.exports = __webpack_public_path__ + "img/23.e0d2ae77.png";